import React from "react";
import { Grid, Layout } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import MainNav from "../Navbars/MainNav";
import Sidebar from "../Navbars/Sidebar";

const { Content } = Layout;
const { useBreakpoint } = Grid;

const AdminLayout = () => {
  const location = useLocation();
  const selectedKey = location.pathname;
  const screens = useBreakpoint();
  const marginLeft = screens.lg ? 90 : 0;

  return (
    <Layout>
      <MainNav />
      <Layout>
        <Sidebar selectedKey={selectedKey} />

        {/* Content area */}
        <Layout
          style={{
            marginLeft: marginLeft,
            paddingInline: "20px",
            overflowY: "auto",
            backgroundColor: "#fff",
          }}
        >
          <Content
            style={{
              margin: "0",
              minHeight: "100%",
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
